import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(memberHasStatus),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(memberIsCartAbandoner);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, select } from 'redux-saga/effects';
import { userProfile } from 'redux/saga/entities/bound';
import { memberStatus as selectMemberStatus, isLoggedIn as selectIsLoggedIn } from 'redux/saga/selectors';
import { memberStatus as memberStatusEnum } from 'enums/memberStatus';
export function memberHasStatus(client, memberStatus) {
  return regeneratorRuntime.wrap(function memberHasStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(selectIsLoggedIn);

        case 2:
          if (!_context.sent) {
            _context.next = 11;
            break;
          }

          _context.next = 5;
          return call(fetchEntityIfNeeded, userProfile, [client]);

        case 5:
          _context.t0 = memberStatusEnum;
          _context.t1 = memberStatus;
          _context.next = 9;
          return select(selectMemberStatus);

        case 9:
          _context.t2 = _context.sent;
          return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

        case 11:
          return _context.abrupt("return", false);

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function memberIsCartAbandoner(client) {
  return regeneratorRuntime.wrap(function memberIsCartAbandoner$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(memberHasStatus, client, 'UNSUBSCRIBED');

        case 2:
          return _context2.abrupt("return", _context2.sent);

        case 3:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}